import { render, staticRenderFns } from "./crearcolegio.vue?vue&type=template&id=8fd7c16e&scoped=true"
import script from "./crearcolegio.vue?vue&type=script&lang=js"
export * from "./crearcolegio.vue?vue&type=script&lang=js"
import style0 from "./crearcolegio.vue?vue&type=style&index=0&id=8fd7c16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd7c16e",
  null
  
)

export default component.exports